import axios from 'axios';

const PortalStudentConduct = {
    namespaced: true,
    actions: {
        CreateStudentConduct({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalStudentConduct/CreateStudentConduct`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateStudentConductMidTerm({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalStudentConduct/CreateStudentConductMidTerm`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetStudentForStudentConduct({ rootState }, { SectionId,ConductId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalStudentConduct/GetStudentForStudentConduct?SectionId=${SectionId}&ConductId=${ConductId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetStudentForStudentConductMidTerm({ rootState }, { SectionId,ConductId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalStudentConduct/GetStudentForStudentConductMidTerm?SectionId=${SectionId}&ConductId=${ConductId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },      

    }
}

export default PortalStudentConduct